import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";

const Schema = Yup.object().shape({
});

export function MerchantEditAddForm({ banner, id, btnRef, saveBannerInfo, type }) {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={banner}
        validationSchema={Schema}
        onSubmit={async (values, { setErrors }) => {
          await saveBannerInfo(values);
        }}
      >
        {({ handleSubmit, field, setFieldValue, values, handleChange, errors }) => (
          <>
            <Form className='form form-label-right'>

              { type === 'wix' &&
                <>
                  <div className='form-group row mt-5'>
                    <Field
                      name="instanceId"
                      component={Input}
                      placeholder='Store ID'
                      label="Store ID"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="state"
                      component={Input}
                      placeholder='Email'
                      label="User Email"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="extra_email"
                      component={Input}
                      placeholder='Secondary Email'
                      label="User Secondary Email"
                    />
                  </div>
                </>
              }
              { type === 'wp' &&
                <>
                  <div className='form-group row mt-5'>
                    <Field
                      name="user_id"
                      component={Input}
                      placeholder='User ID'
                      label="User ID"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="store_url"
                      component={Input}
                      placeholder='Store URL'
                      label="Store URL"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="user_email"
                      component={Input}
                      placeholder='Email'
                      label="User Email"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="user_email2"
                      component={Input}
                      placeholder='Secondary Email'
                      label="User Secondary Email"
                    />
                  </div>
                </>
              }
              { type === 'bc' &&
                <>
                  <div className='form-group row mt-5'>
                    <Field
                      name="user_id"
                      component={Input}
                      placeholder='User ID'
                      label="User ID"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="store_url"
                      component={Input}
                      placeholder='Store URL'
                      label="Store URL"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="user_email"
                      component={Input}
                      placeholder='Email'
                      label="User Email"
                      disabled
                    />
                  </div>
                  <div className='form-group row mt-5'>
                    <Field
                      name="extra_email"
                      component={Input}
                      placeholder='Secondary Email'
                      label="User Secondary Email"
                    />
                  </div>
                </>
              }
              <button
                type='submit'
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}>
              </button>

            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
